import { MessageServiceActions } from "@common/services/messageServiceActions";


export class BackgorundMessageServiceActions extends MessageServiceActions {

  public static sendMessageToTab(cmd: string, data: any): Promise<any[]> {
    // Return the result of the parent class's method
    return super.sendMessageToTab(cmd, data, "backgroundMessageService");
  }

  public static async getCurrentVersion() {
    return BackgorundMessageServiceActions.postMessageToBackgroundWithResponse("getCurrentVersion", {});
  }
}
